export default {
  attachListeners() {
    let searchIcon = jQuery('.search-wrapper .search-icon')
    let closeIcon  = jQuery('.search-wrapper .close')

    searchIcon.on( 'click', this.searchToggle );
    closeIcon.on( 'click', this.searchToggle );
    // console.log('attached listeners')

  },
  searchToggle(event) {


    // Search Wrapper Element
    let container = jQuery(this).closest('.search-wrapper')

    // Check if is active
    if ( !container.hasClass('active')) {
      container.addClass('active');
      event.preventDefault();
    }
    else if ( container.hasClass('active') && jQuery(this).closest('.input-holder').length == 0) {
      container.removeClass('active');
      container.find('.search-input').val('');
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/components/search-form.js